import api from "./api";

export default class ListaBoletoAPI {
  static getBolepix = async (
    page: number,
    RecordsPerPage: number,
    dataInicio: any,
    dataFim: any,
    search: string,
    idCliente: number,
    valorInicio: number,
    valorFim: number,
    idStatus: number,
    ModoPgto: number
  ) => {
    const response = await api.get(
      `/Bolepix?Page=${page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&Search=${search}&idCliente=${idCliente}&valorInicio=${valorInicio}&valorFim=${valorFim}&idStatus=${idStatus}&ModoPgto=${ModoPgto}`
    );
    return response;
  };
}
